/**
 * Route-scoped CSS bundles. Import once per session when entering a feature area.
 * Keeps login/standalone routes from loading CRM, Aria, org chart, etc.
 */

const loaded = new Set<string>();

async function loadOnce(key: string, loader: () => Promise<unknown>): Promise<void> {
  if (loaded.has(key)) return;
  loaded.add(key);
  await loader();
}

export function loadPortalFeatureStyles(): Promise<void> {
  return loadOnce('portal-features', () => import('./bundles/portal-features.css'));
}

export function loadCrmStyles(): Promise<void> {
  return loadOnce('crm', () => import('./bundles/crm.css'));
}

export function loadAriaChatStyles(): Promise<void> {
  return loadOnce('aria-chat', () => import('./bundles/aria-chat.css'));
}

export function loadGodModeStyles(): Promise<void> {
  return loadOnce('god-mode', () => import('./bundles/god-mode.css'));
}

export function loadAnalyticsStyles(): Promise<void> {
  return loadOnce('analytics', () => import('./bundles/analytics.css'));
}

export function loadOrgChartStyles(): Promise<void> {
  return loadOnce('org-chart', () => import('./bundles/org-chart.css'));
}

/** Preload common authenticated shell styles (sidebar layout). */
export function loadAuthenticatedShellStyles(): Promise<void> {
  return loadPortalFeatureStyles();
}
